import PanelRight from "src/Component/PanelRight";
import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store from "src/Reducers/store";
import { Animation } from "@nocios/presentation-kit";
import FrameTV from "src/Component/FrameTV";
import Mic from "./Mic";
import PageSearch from "./PageSearch";
import BottomTV from "src/Component/BottomTV";

const PageId = 6;
const BackPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA = () => {
  const baseImageBG = `${Config.BASE_URL}/images/BG/`;
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);

  const [step, setStep] = useState<number>(0);

  const baseImages = `${Config.BASE_URL}/images/screen_${PageId}/`;

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (PageId !== currentPage) {
      timeout = setTimeout(() => {
        setStep(0);
      }, 600);
    }

    return () => {
      clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step, currentPage]);

  const titles: Record<number, string> = {
    0: "Discover and Organize\nContent Effortlessly",
    3: "Results Tailored Just for You",
  };

  const description: Record<number, string> = {
    0: `Break the barriers of fragmented content libraries\nwith Infosys’ Unified Search & Watchlist. Our\nplatform pulls together shows and movies from\nmultiple streaming services into a single interface.\nUsers can search, organize, and watch their favorite\ncontent across platforms like Disney+, Apple TV,\nand Netflix, all in one place.\n\n<b style="text-decoration: underline;">Voice Search</b>\nSay what you want and let the platform take you\nthere. Search for “Mandalorian,” view its details, and\nopen it directly in Disney+.\n\n<b style="text-decoration: underline;">Unified Watchlist</b>\nBuild your perfect lineup. Add movies and shows to\nyour watchlist from any platform, then access them\ninstantly from the dashboard.`,
    3: "Your search for Bambi has been completed!\nInstantly access detailed information, cast, and\nreviews. Ready to dive in? Select your preferred\nplatform—whether it’s Disney+, Netflix, or Apple TV\n—to start streaming now.",
  };

  const DATA_IMAGES = [
    {
      image: `${baseImages}control.png`,
      effect: "animate-up-hard",
      imageStyle: {
        zIndex: 2000,
        height: "auto",
        top: "auto",
        bottom: 0,
        width: "var(--width-160)",
      },
    },
  ];

  const times = [400, 400];

  return {
    bgImage: `${baseImageBG}BG_2.jpg`,
    title: step < 3 ? titles[0] : titles[3],
    description: step < 3 ? description[0] : description[3],
    rightSideComponent: (
      <PanelRight>
        <FrameTV scrollDisabled={true}>
          <div
            style={{
              position: "absolute",
              left: "var(--width-150)",
              bottom: 0,
              width: "var(--width-150)",
              height: "var(--height-600)",
              zIndex: 200,
              transition: "opacity 0.5s ease",
              opacity: step <= 1 ? 1 : 0,
              display: step > 3 ? "none" : "block",
            }}
          >
            <Animation times={times} pageNumber={PageId} currentPage={currentPage} images={DATA_IMAGES} />
          </div>
          <Mic step={step} setStep={setStep} />
          <PageSearch pageId={PageId} setStep={setStep} step={step} />
        </FrameTV>
        <BottomTV showSkips={step < 6} backPageId={BackPageId} nextPageId={NextPageId} />
      </PanelRight>
    ),
    back: {
      label: "Back",
      type: "back",
      startIcon: { icon: "arrow-right", color: "#fff" },
      onClick: () => setCurrentPage(BackPageId),
      style: {
        gap: "var(--width-16)",
        opacity: step >= 6 ? 1 : 0,
        transition: step !== 0 ? "opacity 0.5s ease" : "",
        zIndex: step >= 6 ? 1 : -1,
      },
    },
    next: {
      label: "Continue",
      type: "next",
      endIcon: { icon: "arrow-left" },
      onClick: () => setCurrentPage(NextPageId),
      style: {
        gap: "var(--width-16)",
        opacity: step >= 6 ? 1 : 0,
        transition: step !== 0 ? "opacity 0.5s ease" : "",
        zIndex: step >= 6 ? 1 : -1,
      },
    },
  };
};

export default DATA;
